import React, { Component } from "react";
import "./memberProfileEdit.css";
import { Link } from "react-router-dom";
import Input from "../UI/input/input";
import * as Moment from "moment";
import { withRouter } from "react-router-dom";
import styled from 'styled-components'

import { iMemberProfile } from "../UI/MemberProfileInterface";
import { ReactComponent as _BackIcon } from "../../assets/left-arrow.svg";


const BackIcon = styled(_BackIcon)`
  width: 20px;
  height: 20px;

  color: #777;
  fill: currentColor;
  transition: all 200ms;

  div &:hover {
    transform: scale(1.3);
  }
`;



class MemberProfileEdit extends Component {
  state = {
    memberFormWasPopulated: false,
    newMemberRegistered: false,
    memberForm: {
      FirstName: {
        label: "Fornavn",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Fornavn"
        },
        value: ""
      },
      LastName: {
        label: "Efternavn",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Efternavn"
        },
        value: ""
      },
      Title: {
        label: "Titel",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Titel"
        },
        value: "",
        canEdit: ["admin"]
      },
      TeamName: {
        label: "Hold",
        elementType: "select",
        elementConfig: {
          options: [],
          placeholder: "Hold"
        },
        value: "",
        canEdit: ["admin", "writer"]
      },
      Postno: {
        label: "Post nummer",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Post nummer"
        },
        value: ""
      },
      Address: {
        label: "Adresse",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Adresse"
        },
        value: ""
      },
      City: {
        label: "By",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "By"
        },
        value: ""
      },
      Phone: {
        label: "Telefon",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Telefon"
        },
        value: ""
      },
      Email: {
        label: "Email",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Email"
        },
        value: ""
      },
      Birthdate: {
        label: "Fødselsdag",
        elementType: "input",
        elementConfig: {
          type: "date",
          placeholder: "Fødselsdag"
        },
        value: ""
      },
      Parent: {
        label: "Forældre",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre"
        },
        value: ""
      },
      ParentPhone: {
        label: "Forældre Telefon",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre Telefon"
        },
        value: ""
      },
      ParentEmail: {
        label: "Forældre Email",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre Email"
        },
        value: ""
      },
      PaymentEmail: {
        label: "Opkrævnings Email",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Opkrævnings Email"
        },
        value: ""
      },
      Started: {
        label: "Startet",
        elementType: "input",
        elementConfig: {
          type: "date",
          placeholder: "Startet"
        },
        value: "",
        canEdit: ["admin"]
      },
      Role: {
        label: "Rolle",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Rolle"
        },
        value: "",
        canEdit: ["admin"]
      },
      ExtraRole: {
        label: "Anden rolle",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Anden rolle"
        },
        value: "",
        canEdit: ["admin"]
      },
      Comment: {
        label: "Kommentar",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Kommentar"
        },
        value: "",
        canEdit: ["admin", "writer"]
      },
      ImageUrl: {
        label: "ImageUrl",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Url til billede"
        },
        value: "",
        canEdit: ["admin", "writer"]
      },
      Status: {
        label: "Status",
        description:
          "Nye medlemmer skal have 'ny' som status, Kasserer skriver 'klar' i feltet, når medlemmet er registreret i kontingent systemet.",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Medlems status"
        },
        value: "",
        canEdit: ["admin", "writer"]
      }
    }
  };

  componentDidUpdate() {
    console.log("MEMBER PROFILE EDIT PROPS: ", this.props);
    // Check if members data has been loaded if not then load members data.
    if (this.props.firebaseReady && this.props.paramsMemberId != "new" && !this.props.membersLoaded) {
      this.props.loadMembers();
    }

    if (!this.props.isAuthenticated) {
      window.history.pushState(null, null, "/login");
      window.history.go();
    }
  }

  goBack() {
    window.history.back();
  }

  inputChanged = (event, elementKey) => {
    const updatedMemberForm = { ...this.state.memberForm };
    const updatedFormElement = { ...updatedMemberForm[elementKey] };
    updatedFormElement.value = event.target.value;
    updatedMemberForm[elementKey] = updatedFormElement;
    this.setState({ memberForm: updatedMemberForm });
  };

  populateFormFromProps() {
    // add data to form if props is present
    const memberForm = { ...this.state.memberForm };
    let memberFormElement = {};

    for (let key in memberForm) {
      // console.log(key, ":", this.props.member[key], "=", memberForm[key]);
      if (this.props.member[key] === undefined) {
        memberFormElement = { ...memberForm[key] };
        memberFormElement.value = "";
      } else {
        memberFormElement = { ...memberForm[key] };
        memberFormElement.value = this.props.member[key];
      }

      // add teams to form element selector
      if (key == "TeamName") {
        // set current memeber team
        memberFormElement = { ...memberForm[key] };
        memberFormElement.value = this.props.member.TeamId;

        let memberFormElementOptions = { ...memberFormElement.elementConfig };
        for (let key in this.props.teams) {
          memberFormElementOptions.options.push({
            value: this.props.teams[key].ID,
            title: this.props.teams[key].TeamName
          });
        }
        memberFormElement.options = {...memberFormElementOptions};

        console.log("memberFormElementOptions", memberFormElementOptions);
      }

      memberForm[key] = memberFormElement;
    }
    this.setState(prevState => {
      return { memberForm, memberFormWasPopulated: true };
    });
  }

  convertFormToMemberData(formData) {
    const memberData = { ...iMemberProfile };

    // find team ID and teamName
    for (let key in formData) {
      if (key == "TeamName") {
        memberData.TeamId = formData[key].value;
        console.log("memberData.TeamId = ", memberData.TeamId);
        for (let key in this.state.teams) {
          if (this.state.teams[key].ID == memberData.TeamId) {
            memberData.TeamName = this.state.teams[key].TeamName;
          }
        }
      } else {
        memberData[key] = formData[key].value ? formData[key].value : null;
      }
    }

    return memberData;
  }

  render() {
    console.log("this.props.member: ", this.props.member)
    console.log("this.props.teams: ", this.props.teams)

    if (!this.props.member || !this.props.teams) return false; // no member data

    if (!this.state.memberFormWasPopulated) {
      this.populateFormFromProps();
    }

    const formElementArry = [];
    for (let key in this.state.memberForm) {
      formElementArry.push({
        id: key,
        config: this.state.memberForm[key]
      });
    }

    const form = (
      <form
        onSubmit={e => {
          e.preventDefault();
          // console.log("ON SUBMIT FORM CLICKED! (props) =>", this.props);
          if (this.props.paramsMemberId == "new") {
            this.props.addNewMemberInternal(e, this.convertFormToMemberData(this.state.memberForm));
          } else {
            // this.props.updateMember(this.state.memberForm);
            this.props.updateMember(this.props.member.ID, this.state.memberForm, true);
            this.props.history.goBack();
          }
        }}
      >
        <input className="input-submit" type="submit" value="Opdatér" />
        <div className="main-input">
          {formElementArry.map(formElement => {
            // May the user edit this element?
            // console.log("canEDIT:", formElement.config.canEdit);
            
            
            // const userMayEdit = true;
            const userMayEdit = formElement.config.canEdit
              ? formElement.config.canEdit.find(ce => {  
                // console.log("userMayEdit-------------: ", this.props.currentlyLoggedInUser.uidProfile.accessType && 
                // this.props.currentlyLoggedInUser.uidProfile.accessType[ce])

                return this.props.currentlyLoggedInUser.uidProfile.accessType && 
                this.props.currentlyLoggedInUser.uidProfile.accessType[ce] == true
                ? true
                : false})
              : true;


            // console.log("userMayEdit:", userMayEdit);

            const inputElement = (
              <Input
                key={formElement.id}
                label={formElement.config.label}
                description={formElement.config.description}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                changed={e => this.inputChanged(e, formElement.id)}
              />
            );

            return userMayEdit ? inputElement : null;
          })}
        </div>
        <input className="input-submit" type="submit" value="Opdatér" />
      </form>
    );

    const memberRanks = this.props.memberRanks.map(mr => {
      if (!mr.level)
        return (
          <div className="error" key={mr.ID}>
            LEVEL MISSING in MEMBER RANK ID=
            <strong>{mr.ID}</strong>
          </div>
        );

      const rankImage = mr.level.LevelImage ? <img className="rank-image" src={"/" + mr.level.LevelImage} alt="levelimage"/> : null;

      return (
        <div className="rank-item" key={mr.level.LevelTitle}>
          <div className="rank-content">
            {rankImage}
            <div className="date-wrapper">
              <div className="date">{Moment(mr.RankDate).format("DD-MM-YYYY")}</div>
              <div className="experience">{Moment(mr.RankDate).fromNow()}</div>
            </div>
            <div className="title-wrapper">
              <div className="title">{mr.level.LevelTitle}</div>
              <div className="descr">{mr.level.LevelDescription}</div>
            </div>
          </div>
          <div className="delete">
            <div className="delete-button" onClick={() => this.props.deleteRankById(mr.ID)}>
              X
            </div>
          </div>
        </div>
      );
    });

    const currentRank =
      this.props.memberRanks[0] && this.props.memberRanks[0].level ? (
        <div className="current-rank">
          {this.props.member.Title ? <span>{this.props.member.Title}, </span> : null}{" "}
          {this.props.memberRanks[0].level.LevelTitle}, {Moment(this.props.memberRanks[0].RankDate).fromNow()}
        </div>
      ) : null;

    const linkToMembers = this.goBack ? (
      <button className="back-button" onClick={this.goBack}>
        <BackIcon />
      </button>
    ) : (
      <Link to="/">
        <BackIcon />
      </Link>
    );

    if (!this.props.member) {
      return null;
    } else {
      const memberImage = this.props.member.ImageUrl ? (
        <div className="memberprofile-image-wrapper">
          <img src={this.props.member.ImageUrl} alt="memberImage"/>
        </div>
      ) : null;

      return (
        <div className="member-edit">
          <div className="nav-wrapper">
            <div className="back-wrapper">{linkToMembers}</div>
          </div>
          <div className="header-wrapper">
            {memberImage}
            <h2>
              {this.props.member.FirstName} {this.props.member.LastName}
            </h2>
            {currentRank}
            <p>{this.props.member.Role}</p>
            <p>{this.props.member.ExtraRole}</p>
            <p className="member-id">{this.props.member.ID}</p>
          </div>

          <div className="main-content-wrapper">
            <div className="member-data">{form}</div>
            <div className="rank-wrapper">{memberRanks}</div>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(MemberProfileEdit);
